<template>
  <div
    class="order-kanban-item"
    @click="$emit('click', item.id)"
    data-no-dragscroll
  >
    <div
      class="
        text-right
        d-flex
        justify-content-between
        order-kanban-item__header
      "
      data-no-dragscroll
    >
      <div class="" data-no-dragscroll>
        {{ item.id }}<span class="text-muted font-size-8 ml-1" v-if="item.text_mark">{{ item.text_mark }}</span> <span class="badge badge-warning ml-1" v-if="item.outsourcing_order == 1" title="Аутсорсинговая поставка">А</span>
      </div>
      <div class="" data-no-dragscroll>
        <b-overlay spinner-small :show="item.loading_sales_manager === true" v-if="!noNames">{{
          salesManagerName
        }}</b-overlay>
      </div>
      <div data-no-dragscroll class="text-primary">
        <span v-if="item.receive_datetime">
          {{ item.receive_datetime | formattedDateTime }}
        </span>
        <span v-else>
          {{ item.created_at | formattedDateTime }}
        </span>
      </div>
    </div>
    <div class="order-kanban-item__substatuses mb-2" data-no-dragscroll v-html="servicesSubs()"></div>
    <div class="order-kanban-item__title line-height-15 mb-2" data-no-dragscroll>
      {{ item.company ? item.company.name : item.temp_name }}
    </div>
    <div
      v-if="!!item.comment && item.comment !== 'null'"
      class="order-kanban-item__desc text-truncate"
      data-no-dragscroll
    >
      {{ item.comment }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    noNames: { 
      type: Boolean, 
      default: false 
    },  // need names in cards or not
    isDragDisabled: {
      type: Boolean,
      default: false
    },  // is drag disabled for this item
  },

  computed: {
    salesManagerName() {
      return (
        (this.item.optional_sales_manager &&
          this.item.optional_sales_manager.name) ||
        (this.item.creator && this.item.creator.name)
      );
    },
  },
  methods: {
    servicesSubs() {
      let TO = false;
      let TEO = false;
      let variantTO = 'secondary';
      let variantTEO = 'secondary';
      let output = '';
      this.item.selected_services.forEach((service) => {
        if (service.id === 23) {
            TEO = true;
        } else {
            TO = true;
        }
      })

      this.item.order_substatuses.forEach((substatus) => {
          if (substatus.reference_substatus_id === 553) {
              variantTO = 'success';
          } else if (substatus.reference_substatus_id === 554) {
              variantTEO = 'success';
          }
      })

      if (TO) {
          output = `<span class="badge badge-${variantTO} ml-1">ТО</span>`;
      }
      if (TEO) {
          output += `<span class="badge badge-${variantTEO} ml-1">ТЭО</span>`;
      }

      return output
    }
  }
};
</script>

<style lang="scss" scoped src="~/components/orderKanban/OrderKanbanItem.scss" />
